import { cn } from "@app/lib/utils";
import { linksDrawerAtom, searchDrawerAtom } from "@design-system/atoms";
import { ColoredInvestmentIcon, InvestmentIcon } from "@design-system/icons";

export function InvestmentButton() {
  const [searchDrawerAtomOpened, linksDrawerAtomOpened] = [
    searchDrawerAtom.useOpened(),
    linksDrawerAtom.useOpened(),
  ];

  return (
    <a
      target="_blank"
      href="https://www.saudiexchange.sa/wps/portal/saudiexchange/hidden/company-profile-main/!ut/p/z1/04_Sj9CPykssy0xPLMnMz0vMAfIjo8ziTR3NDIw8LAz83d2MXA0C3SydAl1c3Q0NvE30I4EKzBEKDMKcTQzMDPxN3H19LAzdTU31w8syU8v1wwkpK8hOMgUA-oskdg!!/?companySymbol=2240"
      // onClick={changeLanguage}
      className={cn(
        "hidden rounded-[4.7rem] border border-transparent bg-white/5 p-3 lg:flex",
        searchDrawerAtomOpened || linksDrawerAtomOpened
          ? "bg-rich-blue !bg-opacity-5"
          : "",
      )}
    >
      {searchDrawerAtomOpened || linksDrawerAtomOpened ? (
        <ColoredInvestmentIcon className="h-8 w-8 max-xl:h-5 max-xl:w-5" />
      ) : (
        <InvestmentIcon className="h-8 w-8 max-xl:h-5 max-xl:w-5" />
      )}
    </a>
  );
}
